"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FieldEditorv2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var react_2 = require("@chakra-ui/react");
var ui_common_1 = require("@codametrix/ui-common");
var field_editorv2_styles_1 = require("./field-editorv2-styles");
var ui_common_2 = require("@codametrix/ui-common");
var svg_icons_1 = require("../svgs/svg-icons");
var isEmpty = ui_common_1.objectUtils.isEmpty;
/**
 * Fetches the initial label for a field based on the cell key, case edits, and value.
 * For 'billing_location' fields, attempts to find a matching label from mapped values.
 * This is not the ideal way to do this, adding support for CDMX-1832
 * Component itself should be able to manage label - value combination in the dropdown
 *
 * @param {string} cellKey - The key identifying the cell/field
 * @param {CMxCommonApp.CaseEditsState} caseEdits - The current case edits state
 * @param {string} value - The current value of the field
 * @returns {string} The label to display, or the original value if no mapping is found
 */
var fetchInitialLabel = function (cellKey, caseEdits, value) {
    var _a;
    if (cellKey === 'billing_location' &&
        !isEmpty(caseEdits) &&
        Object.keys(caseEdits).includes(cellKey)) {
        var mappedValues = (caseEdits === null || caseEdits === void 0 ? void 0 : caseEdits[cellKey]).mappedValues;
        var label = (_a = mappedValues === null || mappedValues === void 0 ? void 0 : mappedValues.find(function (map) {
            return (map === null || map === void 0 ? void 0 : map.value) === value;
        })) === null || _a === void 0 ? void 0 : _a.label;
        return label || value;
    }
    return value;
};
var FieldEditorv2 = function (props) {
    var defaultClassname = 'col-4 col-md-12';
    var cellKey = props.cellKey, label = props.label, value = props.value, fieldType = props.fieldType, onChange = props.onChange, onSubmit = props.onSubmit, fieldEditorInfo = props.fieldEditorInfo, _a = props.className, className = _a === void 0 ? defaultClassname : _a, spreadable = __rest(props, ["cellKey", "label", "value", "fieldType", "onChange", "onSubmit", "fieldEditorInfo", "className"]);
    var classes = (0, classnames_1["default"])("".concat(cellKey, "-editor"), 'field-editorv2', 'encounter-info', className);
    var caseEdits = fieldEditorInfo.caseEdits;
    var updatedValue = value;
    var _b = __read((0, react_1.useState)(fetchInitialLabel(cellKey, caseEdits, value.toString())), 2), selected = _b[0], setSelected = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isMenuOpen = _c[0], setIsMenuOpen = _c[1];
    if (caseEdits && Object.keys(caseEdits).includes(cellKey)) {
        var _d = caseEdits[cellKey], newValue = _d.newValue, initialValue = _d.initialValue;
        updatedValue = (newValue === null || newValue === void 0 ? void 0 : newValue.length) > 0 ? newValue : initialValue !== null && initialValue !== void 0 ? initialValue : 'N/A';
        // setSelected(updatedValue.toString());
    }
    if (fieldType === 'date' && updatedValue !== 'N/A') {
        updatedValue = ui_common_1.cmxDateTime.format(updatedValue.toString(), ui_common_1.cmxDateTime.FORMATS.DATE);
    }
    react_1["default"].useEffect(function () {
        setSelected(fetchInitialLabel(cellKey, caseEdits, value.toString()));
    }, [value]);
    var handleSelect = (0, react_1.useCallback)(function (option) {
        setSelected(option);
        onChange(option);
        setIsMenuOpen(false);
    }, [onChange]);
    // Render menu items only when the menu is open
    var renderMenuItems = (0, react_1.useMemo)(function () {
        if (fieldType === 'dictionary' &&
            caseEdits &&
            caseEdits[cellKey] &&
            isMenuOpen) {
            var options = caseEdits[cellKey].options;
            return options.map(function (option, index) { return ((0, jsx_runtime_1.jsx)(react_2.MenuItem, __assign({ sx: option === selected ? field_editorv2_styles_1.styles.itemSelected : field_editorv2_styles_1.styles.item, onSelect: function () { return handleSelect(option); }, onClick: function () { return handleSelect(option); }, value: option }, { children: option }), "".concat(cellKey, "-").concat(option, "-").concat(index))); });
        }
        return null;
    }, [fieldType, caseEdits, selected, handleSelect, cellKey, isMenuOpen]);
    return (
    //@ts-ignore
    (0, jsx_runtime_1.jsxs)("div", __assign({}, spreadable, { className: classes }, { children: [fieldType === 'date' && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "datepicker-qa date-field-editor" }, { children: (0, jsx_runtime_1.jsx)(react_datepicker_1["default"], { selected: selected !== 'N/A' || null || undefined
                        ? new Date("".concat(selected, " 00:00"))
                        : null, placeholderText: 'No Date Selected', onChange: function (e) {
                        var newTime = e.toISOString().split('T')[0];
                        setSelected(newTime);
                        onChange(newTime);
                    } }, updatedValue.toString()) }))), fieldType === 'dictionary' && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "dictionary-menu-button", "data-tooltip": selected }, { children: (0, jsx_runtime_1.jsx)(react_2.ChakraProvider, { children: (0, jsx_runtime_1.jsxs)(react_2.Menu, __assign({ onOpen: function () { return setIsMenuOpen(true); }, onClose: function () { return setIsMenuOpen(false); } }, { children: [(0, jsx_runtime_1.jsx)(react_2.Tooltip, __assign({ label: selected, placement: "top" }, { children: (0, jsx_runtime_1.jsx)(react_2.MenuButton, __assign({ as: react_2.Button, sx: field_editorv2_styles_1.styles.button, 
                                    //key={updatedValue.toString()}
                                    rightIcon: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeChevronDownSVG20", svgIconSize: "20", svgIconClass: "select-checvron" }), _focus: { boxShadow: 'none' }, _expanded: {
                                        bg: ui_common_2.theme.colors.text['light'],
                                        border: "".concat(ui_common_2.theme.borders['1px'], " ").concat(ui_common_2.theme.colors.foundation[500])
                                    }, _hover: {
                                        border: "".concat(ui_common_2.theme.borders['1px'], " ").concat(ui_common_2.theme.colors.foundation[400]),
                                        bg: ui_common_2.theme.colors.text['light']
                                    } }, { children: selected !== 'N/A' ? "".concat(selected) : 'No Selection' })) })), (0, jsx_runtime_1.jsx)(react_2.MenuList, __assign({ sx: field_editorv2_styles_1.styles.list, style: { overflow: 'auto' }, width: "200px" }, { children: isMenuOpen && renderMenuItems }))] })) }) })))] })));
};
exports.FieldEditorv2 = FieldEditorv2;
FieldEditorv2.displayName = 'FieldEditorv2';
//# sourceMappingURL=field-editorv2.js.map